import { Component, Input, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { UserAccountHomeDto, UserAccountRegDto } from 'src/app/core/dtos/dto';
import { DateTimeHelper } from 'src/app/core/services/helpers/date-time.helper';
import { selectBusinessAccountParentKey } from 'src/app/state/business-account-parent-key.selector';
import { selectMyAccount } from 'src/app/state/my-account.selectors';

@Component({
  selector: 'app-web-delivery',
  templateUrl: './web-delivery.component.html',
  styleUrls: ['./web-delivery.component.scss']
})
export class WebDeliveryComponent implements OnInit {

  @Input() reg: UserAccountRegDto;
  @Input() isUpcomingTest?: boolean;

  myAccount$: Observable<UserAccountHomeDto>;
  businessAccountParentKey$: Observable<AuthModel>;
  localTimeZone: string;
  testDate: Date;

  constructor(
    private store: Store,
    private dateTimeHelper: DateTimeHelper
  ) { }

  ngOnInit(): void {
    this.localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    this.myAccount$ = this.store.pipe(select(selectMyAccount));
    this.businessAccountParentKey$ = this.store.pipe(select(selectBusinessAccountParentKey));
    this.testDate = this.dateTimeHelper.convertUTCDateToLocalDate(new Date(this.reg.testDateTimeUtc));
  }

}
